import Spells from './Spells';

export default Spells;
export { Spells };
